import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import { Types as UserTypes, Creators as UserActions } from '../ducks/User';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getUsers({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/clients', {
      params: payload,
    });
    if (status === 200) {
      yield put(UserActions.getUsersSuccess(data));
    }
    else {
      Sentry.captureMessage('getUsers failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UserActions.getUsersError('Error listing users'));
  }
}

function* postUser({ payload }) {
  try {
    const { status } = yield call(api.post, '/clients', payload);
    if (status === 200) {
      yield put(UserActions.postUserSuccess());
    }
    else {
      Sentry.captureMessage('postUser failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UserActions.postUserError('Error registering user'));
  }
}

function* getUserById({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/clients/${payload}`);
    if (status === 200) {
      yield put(UserActions.getUserByIdSuccess(data));
    }
    else {
      Sentry.captureMessage('getUserById failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UserActions.getUserByIdError('Error listing user'));
  }
}

function* putUser({ payload }) {
  const { userId } = payload;
  try {
    const { status } = yield call(api.put, `/clients/${userId}`, payload.data);
    if (status === 200) {
      yield put(UserActions.putUserSuccess());
    }
    else {
      Sentry.captureMessage('putUser failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(UserActions.putUserError('Error editing user'));
  }
}

function* getUsersWatcher() {
  yield takeLatest(UserTypes.GET_USERS, getUsers);
}
function* postUserWatcher() {
  yield takeLatest(UserTypes.POST_USER, postUser);
}
function* getUserByIdWatcher() {
  yield takeLatest(UserTypes.GET_USER_BY_ID, getUserById);
}
function* putUserWatcher() {
  yield takeLatest(UserTypes.PUT_USER, putUser);
}
export default function* rootSaga() {
  yield all([
    fork(getUsersWatcher),
    fork(postUserWatcher),
    fork(getUserByIdWatcher),
    fork(putUserWatcher),
  ]);
}
